import { authRequests } from './auth';
import { usersRequests } from './users';
import { greenhouseRequests } from './greenhouse';
import { varietyRequests } from './variety';
import { uploadRequests } from './upload';
import { alertRequests } from './alert';
import { zoneRequests } from './zone';
import { configRequests } from './config';

export const API = {
  auth: authRequests,
  users: usersRequests,
  greenhouse: greenhouseRequests,
  zone: zoneRequests,
  variety: varietyRequests,
  upload: uploadRequests,
  alert: alertRequests,
  config: configRequests
};
